<template>
  <div>
    <h3>
      <template v-if="mainMember === true">
        Informations sur le membre principal
      </template>
      <template v-else>
        Informations sur le membre
      </template>
    </h3>

    <br />

    <b-form-row>
      <b-col>
        <b-form-group label="Prénom">
          <b-form-input
              v-model="member.firstName"
              type="text"
              :state="validateState('firstName')"
              aria-describedby="input-first-name-feedback"
              @input="setField('firstName', $event)"
          />
          <b-form-invalid-feedback id="input-first-name-feedback">
            Veuillez entrer votre prénom.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Nom de famille">
          <b-form-input
              v-model="member.lastName"
              type="text"

              :state="validateState('lastName')"
              aria-describedby="input-last-name-feedback"
              @input="setField('lastName', $event)"
          />
          <b-form-invalid-feedback id="input-last-name-feedback">
            Veuillez entrer votre nom de famille.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row v-if="askForEmail === true">
      <b-col>
        <b-form-group label="Adresse courriel">
          <b-form-input
              type="email"
              v-model="member.email"

              :state="validateState('email')"
              aria-describedby="input-email-feedback"
              @input="setField('email', $event)"
          />
          <b-form-invalid-feedback id="input-email-feedback">
            <template v-if="!$v.member.email.required">
              Veuillez entrer votre adresse courriel.
            </template>
            <template v-else-if="!$v.member.email.email">
              Veuillez entrer une adresse courriel valide.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group label="Date de naissance">
          <datetime
              v-model="member.birthday"
              value-zone="America/New_York"
              aria-describedby="input-birthday-feedback"
              @input="setField('birthday', $event)"
              class="form-control"
              :class="{
              'is-invalid': !$v.member.birthday.required && $v.member.birthday.$dirty,
              'is-valid': $v.member.birthday.required && $v.member.birthday.$dirty
            }"
          />
          <div
              class="invalid-feedback"
              id="input-birthday-feedback"
              v-if="!$v.member.birthday.required && $v.member.birthday.$dirty"
          >
            Veuillez entrer votre date d'anniversaire.
          </div>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group label="Téléphone principal">
          <the-mask
              mask="### ###-#### poste ########"
              :class="{
              'form-control': true,
              'is-invalid': !$v.member.phonePrincipal.required && $v.member.phonePrincipal.$dirty,
              'is-valid': $v.member.phonePrincipal.required && $v.member.phonePrincipal.$dirty
            }"
              type="tel"
              :masked="true"
              v-model="member.phonePrincipal"
              :state="validateState('phonePrincipal')"
              aria-describedby="input-phone-principal-feedback"
              @input="setField('phonePrincipal', $event)"
          />
          <div
              class="invalid-feedback"
              id="input-phone-principal-feedback"
              v-if=" !$v.member.phonePrincipal.required && $v.member.phonePrincipal.$dirty"
          >
            Veuillez entrer au minimum un numéro de téléphone principal ou
            cellulaire.
          </div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Téléphone cellulaire">
          <the-mask
              mask="### ###-####"
              :class="{
              'form-control': true,
              'is-invalid':  !$v.member.phonePrincipal.required && $v.member.phonePrincipal.$dirty,
              'is-valid': $v.member.phonePrincipal.required && $v.member.phonePrincipal.$dirty
            }"
              type="tel"
              :masked="true"
              aria-describedby="input-phone-mobile-feedback"
              v-model="member.phoneMobile"
          />
          <div
              class="invalid-feedback"
              id="input-phone-mobile-feedback"
              v-if="!$v.member.phonePrincipal.required && $v.member.phonePrincipal.$dirty"
          >
            Veuillez entrer au minimum un numéro de téléphone principal ou
            cellulaire.
          </div>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group label="Formation académique">
          <b-input v-model="member.formation" />
        </b-form-group>
        <b-form-group label="Occupation">
          <b-input v-model="member.occupation" />
        </b-form-group>
        <b-form-group label="Désirez-vous recevoir les messages du COQ?">
          <b-checkbox v-model="member.newsletter" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Êtes-vous intéressé à faire partie d'un comité?">
          <b-form-checkbox-group
              :multiple="true"
              v-model="member.commitees"
          >
            <b-form-checkbox value="Bulletin_textes" >
              Bulletin ornithologique (textes et photos)
            </b-form-checkbox>
            <b-form-checkbox value="Activites_excursions" >
              Activités et excursions
            </b-form-checkbox>
            <b-form-checkbox value="Kiosques_salons" >
              Kiosques et salons
            </b-form-checkbox>
            <br/>
            <b-form-checkbox value="CA" >
              Membre du conseil d'administration
            </b-form-checkbox>
            <b-form-checkbox value="Compilations_observations" >
              Compilations et observations
            </b-form-checkbox>
            <b-form-checkbox value="Recherche_commanditaires" >
              Recherches de commanditaires
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
  import { Datetime } from 'vue-datetime';
  const {
    required,
    minLength,
    email,
    sameAs,
    requiredIf
  } = require('vuelidate/lib/validators');

  export default {
    name: 'register-member',
    props: {
      mainMember: {
        type: Boolean,
        default: () => false
      },
      member: {
        type: Object,
        default: () => {
          return {
            firstName: '',
            lastName: '',
            phonePrincipal: '',
            phoneMobile: '',
            commitees: [],
            newsletter: true
          };
        }
      },
      askForEmail: {
        type: Boolean,
        default: false
      }
    },
    components: { Datetime },
    data() {
      return {
        inputProps: {
          class: 'form-control',
          placeholder: 'Veuillez entrer votre date d\'anniversaire'
        }
      };
    },
    mounted() {
      setTimeout(() => {
        this.$v.member.birthday.$reset();
      }, 100);
    },
    validations: {
      member: {
        firstName: {
          required,
          minLength: minLength(2)
        },
        lastName: {
          required,
          minLength: minLength(2)
        },
        birthday: {
          required
        },
        email: {
          email,
          required: requiredIf(function() {
            return this.askForEmail;
          })
        },
        phonePrincipal: {
          required: requiredIf(function() {
            console.log('MOBILE PHONE', this.member.phoneMobile);
            return (
              this.member.phoneMobile === undefined ||
              this.member.phoneMobile === null ||
              this.member.phoneMobile === ''
            );
          })
        }
      }
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.member[name];
        return $dirty ? !$error : null;
      },
      setField(field, street) {
        this.member[field] = street;
        this.$v.member[field].$touch();
      },
      check() {
        this.$v.member.$touch();
        return !this.$v.member.$anyError;
      }
    }
  };
</script>

<style scoped></style>
